import AppFrame from '@/components/AppFrame';
import { useViewerQuery } from '@/generated/graphql';
import { useRouter } from 'next/router';
import React from 'react';

interface WithoutUserFrameProps {
  redirectUrl?: string;
  /**
   * Stay on the page although the browser is signed in: a client asked for
   * a new sign-in (OAuth prompt=login or max_age).
   */
  holdRedirect?: boolean;
  children: React.ReactNode;
}

export default function WithoutUserFrame({
  children,
  redirectUrl = '',
  holdRedirect = false,
}: WithoutUserFrameProps): JSX.Element {
  const router = useRouter();
  const { loading, data } = useViewerQuery();

  const viewer = data?.viewer;

  // Wait for router.isReady: on a hard load of /signin?returnUrl=...,
  // router.query is empty until then, so redirecting early would compute the
  // target from a missing returnUrl and drop the deep link.
  if (!loading && viewer && router.isReady && !holdRedirect) {
    router.push(redirectUrl || '/');
  }

  return <AppFrame loading={loading}>{children}</AppFrame>;
}
